export default (state, profile) => {
  state.loggedin.profile = profile;
}


// WEBPACK FOOTER //
// ./src/app/store/users/mutations/set-logged-in-profile.js